export type LogLevel = 'off' | 'error' | 'warn' | 'info' | 'debug';

const LEVELS: Record<LogLevel, number> = {
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
};

const env = typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_LOG_LEVEL : undefined;
const currentLevel = LEVELS[(env ?? 'debug').toLowerCase() as LogLevel] ?? LEVELS.debug;

const logger = {
  error: (message: string, ...args: unknown[]) => {
    if (currentLevel >= LEVELS.error) console.error(message, ...args);
  },
  warn: (message: string, ...args: unknown[]) => {
    if (currentLevel >= LEVELS.warn) console.warn(message, ...args);
  },
  info: (message: string, ...args: unknown[]) => {
    if (currentLevel >= LEVELS.info) console.log(message, ...args);
  },
  debug: (message: string, ...args: unknown[]) => {
    if (currentLevel >= LEVELS.debug) console.log(message, ...args);
  },
};

export default logger;
